// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

$w.onReady(function () {
	// Write your JavaScript here

	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});

export function expand01_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 

		$w("#image0101").expand();
		$w("#image0102").expand();
		$w("#description01").expand();
		$w("#expand01").hide();
		$w("#collapse01").show();

}

export function collapse01_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w("#image0101").collapse();
	$w("#image0102").collapse();
	$w("#description01").collapse();
	$w("#collapse01").hide();
	$w("#expand01").show();
	
}

export function expand02_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
		$w("#image0201").expand();
		$w("#image0202").expand();
		$w("#description02").expand();
		$w("#expand02").hide();
		$w("#collapse02").show();

}

export function collapse02_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w("#image0201").collapse();
	$w("#image0202").collapse();
	$w("#description02").collapse();
	$w("#collapse02").hide();
	$w("#expand02").show();
}

export function collapse03_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w("#image0301").collapse();
	$w("#image0302").collapse();
	$w("#description03").collapse();
	$w("#collapse03").hide();
	$w("#expand03").show();
}

export function expand03_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
		$w("#image0301").expand();
		$w("#image0302").expand();
		$w("#description03").expand();
		$w("#expand03").hide();
		$w("#collapse03").show();
}

export function expand04_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
		$w("#image0401").expand();
		$w("#image0402").expand();
		$w("#description04").expand();
		$w("#expand04").hide();
		$w("#collapse04").show();
}

export function collapse04_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w("#image0401").collapse();
	$w("#image0402").collapse();
	$w("#description04").collapse();
	$w("#collapse04").hide();
	$w("#expand04").show();
}

export function collapse05_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w("#image0501").collapse();
	$w("#image0502").collapse();
	$w("#description05").collapse();
	$w("#collapse05").hide();
	$w("#expand05").show();
}

export function expand05_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
		$w("#image0501").expand();
		$w("#image0502").expand();
		$w("#description05").expand();
		$w("#expand05").hide();
		$w("#collapse05").show();
}

export function expandallbutton_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	if ( $w("#expandallbutton").label === 'Expand All' ){
		// expanding
		expand01_click(event);
		expand02_click(event);
		expand03_click(event);
		expand04_click(event);
		expand05_click(event);
		$w("#expandallbutton").label = 'Collapse All';
	} else {
		// collapsing
		collapse01_click(event);
		collapse02_click(event);
		collapse03_click(event);
		collapse04_click(event);
		collapse05_click(event);
		$w("#expandallbutton").label = 'Expand All';
	}
}